import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, Dropdown, DropdownButton,FormControl, Modal} from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';
import NumberFormat from 'react-number-format';
import { store } from 'react-notifications-component';

import Connection from '../../../Calls'
import Backend from '../../..//Backend'
import PhoneInput from 'react-phone-input-2';


import '../index.css'
import Card from '../../../Images/Ejemplo_Tarjeta.png'
import Card2 from '../../../Images/landing/SeccionTarjeta/tarjeta-wb-azul-sola.png'
import Logo from '../../../Images/logo-wirebit-pdf.png'


import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import icons from '../../Landing/icons.json'

import ImgIDFront from '../../../Images/document-ID-front.png'
import ImgIDBack from '../../../Images/document-ID-back.png'
import ImgUBill from '../../../Images/document-utilitybill.png'
import ImgBank from '../../../Images/document-bankstatement.png'
import { Bounce } from 'react-activity';


function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

export default class CardView extends Component {
  constructor(props){
    super(props)
    this.state = {
        tab:'card',
        StartDate:'',
        EndDate:'',
        DpOrWd:'dp',
        lock:false,
        transactions:[{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},
            {type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},
            {type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},
            {type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},
            {type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"},{type:'expense', amount:'10 usd', concept:"7 ELEVEN 1593 SN PEDRO GARZ MEX", fecha:"Feb 2"}
        ],
        modalValidatePhone:false,
        modalValidateCodePhone:false,
        codeValidate:'',
        cellphoneValidate:'',
        formulario:false,
        bucket:'',


        imgIdFront:'',
        imgFileIdFront:'',
        base64IdFront:'',
        base64TypeIdFront:'',
        imgNameIdFront:'',

        imgIdBack:'',
        imgFileIdBack:'',
        base64IdBack:'',
        base64TypeIdBack:'',
        imgNameIdBack:'',

        imgPaddOrAccSte:'',
        imgFilePaddOrAccSte:'',
        base64PaddOrAccSte:'',
        base64TypePaddOrAccSte:'',
        imgNamePaddOrAccSte:'',

        Name :'',
        Last_name :'',
        Street_address :'',
        State :'',
        Zip_code:'',
        CellphoneVerified:'',
        ClientInfo:{},
        Loading:false
    }
  }

  /* --------------------------------- Methods -------------------------------- */
  addNotification(status,msg,type){
    store.addNotification({
      title: status,
      message: msg,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 2500,
        onScreen: true
      }
    });
  }
  componentDidMount(){
    var date = new Date();
    this.setState({
        StartDate: new Date(date. getFullYear(), date. getMonth(), 1),
        EndDate:new Date(date. getFullYear(), date. getMonth() + 1, 0)
    })
    this.GetPlans();
    this.GetInformation();
  }
  _onChangeIdFront() {
    const self = this;

    var file = this.refs.imgIdFront.files[0];
    var fileType = file.name.split(".")[file.name.split(".").length-1].toLowerCase()

    var reader = new FileReader();
    reader.readAsDataURL(file);

    if (file.size > 2097152) {
      document.getElementById("imgIdFront").value = "";
      self.setState({
        imgIdFront: "",
        imgFileIdFront: "",
      })
      this.addNotification("Error!","Image exceeds 2MB.","danger");
    } else if (fileType != 'jpeg' && fileType != 'png'){
      document.getElementById("imgIdFront").value = "";
      this.addNotification("Error!", "Only .jpeg or .png files are acceptable","danger");
      self.setState({
        imgIdFront: "",
        imgFileIdFront: "",
      })
    } else {
      reader.onloadend = function (e) {
        var image_split = [reader.result][0];
        self.setState({
          imgIdFront: [reader.result],
          base64IdFront: image_split.split(",")[1],
          base64TypeIdFront: fileType,
          imgFileIdFront: file,
          imgNameIdFront: file.name,
        })
      }.bind(this);
    }
  }
  _onChangeIdBack() {
    const self = this;
    var file = this.refs.imgIdBack.files[0];
    var fileType = file.name.split(".")[file.name.split(".").length-1].toLowerCase();
    var reader = new FileReader();
    reader.readAsDataURL(file);
    if (file.size > 2097152) {
      document.getElementById("imgIdBack").value = "";
      this.addNotification("Error!","Image exceeds 2MB.","danger");
      self.setState({
        imgIdBack: "",
        imgFileIdBack: "",
      })
    } else if (fileType != 'jpeg' && fileType != 'png'){
      document.getElementById("imgIdBack").value = "";
      this.addNotification("Error!", "Only .jpeg or .png files are acceptable","danger");
      self.setState({
        imgIdBack: "",
        imgFileIdBack: "",
      })
    } else {
      reader.onloadend = function (e) {
        var image_split = [reader.result][0];
        this.setState({
          imgIdBack: [reader.result],
          base64IdBack: image_split.split(",")[1],
          base64TypeIdBack: fileType,
          imgFileIdBack: file,
          imgNameIdBack: file.name
        })
      }.bind(this);
    }
  }
  _onChangePaddOrAccSte() {
    const self = this;

    var file = this.refs.imgPaddOrAccSte.files[0];
    var fileType = file.name.split(".")[file.name.split(".").length-1].toLowerCase()

    var reader = new FileReader();
    reader.readAsDataURL(file);

    if (file.size > 2097152) {
      document.getElementById("imgPaddOrAccSte").value = "";
      self.setState({
        imgPaddOrAccSte: "",
        imgFilePaddOrAccSte: "",
      })
      this.addNotification("Error!","Image exceeds 2MB.","danger");
    } else if (fileType != 'jpeg' && fileType != 'png'){
      document.getElementById("imgPaddOrAccSte").value = "";
      this.addNotification("Error!", "Only .jpeg or .png files are acceptable","danger");
      self.setState({
        imgPaddOrAccSte: "",
        imgFilePaddOrAccSte: "",
      })
    } else {
      reader.onloadend = function (e) {
        var image_split = [reader.result][0];
        self.setState({
          imgPaddOrAccSte: [reader.result],
          base64PaddOrAccSte: image_split.split(",")[1],
          base64TypePaddOrAccSte: fileType,
          imgFilePaddOrAccSte: file,
          imgNamePaddOrAccSte: file.name,
        })
      }.bind(this);
    }
  }
  /* ---------------------------------- Calls --------------------------------- */
  GetPlans() {
    const self = this;

    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.PricingPlansLogged(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
        if (response.status.code === "0") {
          self.setState({
            list_plans_info_user: response.payload.info,
            Cellphone: response.payload.info.cellphone,
            bucket:response.payload.info.bucket,
            CellphoneVerified: response.payload.info.cellphone_verified,
          });

        } else {
          self.setState({ list_plans: [] });
        }
      });
    });
  }
  RequestCard(){
    this.setState({Loading:true})
    window.scroll(0,0);
    const self = this;
    self.setState({ spinner: true })
      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
       
        Backend.RequestCard(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
          if (response.status.code === "0") {
            this.props.GetStatusCard();
            this.setState({Loading:false})
          } else {
            this.setState({Loading:false})
          }
        });
      });

  }
  GetInformation = () => {
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });

    result = latitude + longitude;

    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        Backend.get_client_data(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
            if(response.status.code == '0'){
              this.setState({ClientInfo:response.payload.client_info})
            }
        });
    });
}
  /* --------------------------------- Renders -------------------------------- */
 
  renderDocs(){
    return(
      <Row style={{justifyContent:'center'}}>
        <Col md={3}>
           <div>
            {/* image id front */}
            <div className="margin_bottom_ten_pixels">
              <p className="label-plans no_margin_bottom">Image ID front:</p>
              <div>
                <div className="input_files_image">
                      {
                        (this.state.imgIdFront === "")
                          ? <div className="container_file_image_display_flex">
                            <div style={{textAlign:'center'}}>
                              <Image src={ImgIDFront} style={{marginBottom:10}} fluid />
                              <Form.Control
                                style={{ width: "fit-content", fontSize: 12 }}
                                ref="imgIdFront"
                                id="imgIdFront"
                                type="file"
                                name="user[image]"
                                multiple={false}
                                accept="image/png, image/jpeg"
                                size="2000000"
                                onChange={() => { this._onChangeIdFront() }}
                              />
                              <p style={{ fontSize: 12, textAlign: "center", color: "#053164", fontWeight: "bold" }}>Files should be .jpeg or .png and cannot be bigger than 2MB</p>
                            </div>
                          </div>
                          : <div>
                            <Image src={this.state.imgIdFront} style={{ width: "100%", height: 246 }} fluid />
                            <div className="container_button_cancel_file">
                              <Button className="button_choose_plan_cancel" onClick={() => { this.setState({ imgIdFront: "", imgFileIdFront: "" }) }}>Cancel</Button>
                            </div>
                          </div>
                      }
                    </div>
              </div>
            </div>
          </div>
        </Col>
        <Col md={3}>
           <div>
            {/* image id front */}
            <div className="margin_bottom_ten_pixels">
              <p className="label-plans no_margin_bottom">Image ID back:</p>
              <div>
                <div className="input_files_image">
                      {
                        (this.state.imgIdBack === "")
                          ? <div className="container_file_image_display_flex">
                            <div style={{textAlign:'center'}}>
                              <Image src={ImgIDBack} style={{marginBottom:10}} fluid />
                              <Form.Control
                                style={{ width: "fit-content", fontSize: 12 }}
                                ref="imgIdBack"
                                id="imgIdBack"
                                type="file"
                                name="user[image]"
                                multiple={false}
                                accept="image/png, image/jpeg"
                                size="2000000"
                                onChange={() => { this._onChangeIdBack() }}
                              />
                              <p style={{ fontSize: 12, textAlign: "center", color: "#053164", fontWeight: "bold" }}>Files should be .jpeg or .png and cannot be bigger than 2MB</p>
                            </div>
                          </div>
                          : <div>
                            <Image src={this.state.imgIdBack} style={{ width: "100%", height: 246 }} fluid />
                            <div className="container_button_cancel_file">
                              <Button className="button_choose_plan_cancel" onClick={() => { this.setState({ imgIdBack: "", imgFileIdBack: "" }) }}>Cancel</Button>
                            </div>
                          </div>
                      }
                    </div>
              </div>
            </div>
          </div>
        </Col>
        <Col md={3}>
           <div>
            {/* image id front */}
            <div className="margin_bottom_ten_pixels">
              <p className="label-plans no_margin_bottom">Proof of address or account statement:</p>
              <div>
                <div className="input_files_image">
                      {
                        (this.state.imgPaddOrAccSte === "")
                          ? <div className="container_file_image_display_flex">
                            <div style={{textAlign:'center'}}>
                              <Image src={ImgUBill} style={{marginBottom:10}} fluid />
                              <Form.Control
                                style={{ width: "fit-content", fontSize: 12 }}
                                ref="imgPaddOrAccSte"
                                id="imgPaddOrAccSte"
                                type="file"
                                name="user[image]"
                                multiple={false}
                                accept="image/png, image/jpeg"
                                size="2000000"
                                onChange={() => { this._onChangePaddOrAccSte() }}
                              />
                              <p style={{ fontSize: 12, textAlign: "center", color: "#053164", fontWeight: "bold" }}>Files should be .jpeg or .png and cannot be bigger than 2MB</p>
                            </div>
                          </div>
                          : <div>
                            <Image src={this.state.imgPaddOrAccSte} style={{ width: "100%", height: 246 }} fluid />
                            <div className="container_button_cancel_file">
                              <Button className="button_choose_plan_cancel" onClick={() => { this.setState({ imgPaddOrAccSte: "", imgFilePaddOrAccSte: "" }) }}>Cancel</Button>
                            </div>
                          </div>
                      }
                    </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    )
  }
  render(){
    return(
        <div>
          <div className="contenedor-wallets-generals">
            <Container fluid>
              <Row>
                <Col lg={{span:10, offset:1}}>
                    <Row style={{flex:1,zIndex:2}}>
                        {
                            
                            <>
                            
                            <Col lg={12} md={12} className="container-cards ">
                                {/* <div className="container-cards1 solicitud">
                                    <div>
                                        <Image className='logo' src={Logo}/>
                                        <Image src={Card2}/>
                                    </div>
                                </div> */}
                                <div className="container-transactionsCard solicitud">
                                  <Image className='logo' src={Logo}/>
                                  <Image src={Card2} style={{width:"334px", marginTop: '60px'}}/>

                                  <p className='title-container-shadow' style={{marginBottom:15}}>{this.props.traductions.Card.disabled.note1}</p>
                                 


                                  {
                                    (this.state.ClientInfo.type )&&
                                    (this.state.ClientInfo.type != 'free' )
                                    ? 
                                      <Button className="btn-requestCard" disabled={this.state.Loading} onClick={()=>this.RequestCard()}>
                                        {
                                            (this.state.Loading)
                                            ? <Bounce size={20} color={"#FFFFFF"} animating={true} />
                                            : this.props.traductions.Card.disabled.btn
                                        }
                                      </Button>
                                    :(this.state.ClientInfo.pending_upgrade == 'rejected')
                                      ?
                                        <div className='incompleteRecord'>
                                            <p style={{margin:0}}>{this.props.traductions.General.registerResponse.rejected1}</p>
                                            <p>{this.props.traductions.General.registerResponse.rejected2} <span className='link' onClick={()=>this.props.data.history.push("/kyc") }>{this.props.traductions.General.registerResponse.click}</span></p>
                                        </div>
                                      :(this.state.ClientInfo.pending_upgrade != 'False')
                                        ?
                                            <div className='incompleteRecord'>
                                                <p style={{margin:0}}>{this.props.traductions.General.registerResponse.revision}</p>
                                            </div>
                                        :
                                            <div className='incompleteRecord'>
                                                <p >{this.props.traductions.General.registerResponse.unregistered1}</p>
                                                <p>{this.props.traductions.General.registerResponse.unregistered2} <span className='link' onClick={()=>this.props.data.history.push("/kyc") }>{this.props.traductions.General.registerResponse.click}</span></p>
                                            </div>
                                  }




                                  

                                  <p className='title-container-shadow' style={{fontSize:16, marginTop:30}}>{formatMoney(this.props.card_cost)} USD {this.props.traductions.Card.disabled.note2}.</p>

                                </div>
                            </Col>
                            </>

                        }
                       </Row>
                    <div className={(this.state.formulario== "True")?'':"blurGRAY"} ></div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
    )
  }
}
